<template>
  <div class="search-content-top">
    <div class="container text-center">
      <div class="rating-container">
        <template v-if="ratingsTotal > 0 && ratingsAVG > 0">
          <div class="rating-stars">
            <rating-stars :percent="(ratingsAVG / 5) * 100" />
            <em>
              {{ $t('common:seoTotalRatings', { ratingsAVG, ratingsTotal }) }}
            </em>
          </div>
        </template>
      </div>

      <div v-show="contentText1">
        <a
          v-smooth-scroll="{
            updateHistory: false,
          }"
          href="#searchResult"
          class="btn btn-primary d-xl-none"
        >
          {{ $t('search:toOffers') }}
        </a>
      </div>

      <div>
        <span
          ref="contextText1Ref"
          v-dompurify-html="contentText1"
          class="search-content-top-text"
        />
        <span>
          <a
            v-show="showReadMoreBtn"
            v-smooth-scroll="{updateHistory: false}"
            class="readMore link-underline"
            href="#regionInfo"
          >{{ $t('search:readMore') }}</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import RatingStars from 'components/RatingStars.vue';
import setupTipTapApi from 'mixins/composition/TiptapApi';

export default {
  components: {
    RatingStars,
  },
  props: {
    content: {
      type: Object,
      default() { return {}; },
    },
  },
  setup(props, { root }) {
    // check if tiptap content is on bottom of page to maybe show "read more" button
    const tiptapApiComposition = setupTipTapApi({
      store: root.$store,
      route: root.$route,
      bvToast: root.$bvToast,
      i18next: root.$i18n.i18next,
      containerKey: 'searchContentBottom',
    });

    return {
      tiptapContentLivePublished: tiptapApiComposition.tiptapContentLivePublished,
    };
  },
  i18nOptions: { namespaces: ['common', 'search'] },
  computed: {
    ratingsTotal() {
      return this.$store.getters.getRatingsTotal;
    },
    ratingsAVG() {
      return this.$store.getters.getRatingsAVG;
    },
    contentText1() {
      return this.content?.text1 || '';
    },
    showReadMoreBtn() {
      return !!(this.content?.text2 || this.tiptapContentLivePublished);
    }
  },
};
</script>
<style lang="scss" scoped>
  .search-content-top {
    padding: $margin_content * 1.5 0;
  }

  .rating-container {
    min-height: 5.4em;

    @media #{$media_xxs} {
      min-height: 6.5em;
    }

    @media #{$media_md_min} {
      min-height: 4.43em;
    }
  }

  .rating-stars {
    display: block;

    .rating-stars-canvas {
      margin: 0 auto;

      @include font_size_xl;
    }

    em {
      margin: 0.5em 0 1em;
      display: block;
    }
  }

  .btn {
    margin: 0.25em auto 0.75em;
  }

  .search-content-top-text {
    margin: 1em 0 0;
    text-align: left;
  }

  a.readMore {
    display: inline-block;
    margin-left: 0.5em;
  }
</style>
